import DataTable from "app/components/DataTable";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { FrontClearanceRow } from "../types";
import { useStyles } from "./styles";

type Props = {
  rows: FrontClearanceRow[];
  loading?: boolean;
};

const formatCellValue = (value?: string | number | null): string | number => {
  if (value == null || value === "") {
    return "-";
  }

  return value;
};

const renderValue = (
  value: Parameters<typeof formatCellValue>[0],
  styles: ReturnType<typeof useStyles>
) => <span className={styles.textCell}>{formatCellValue(value)}</span>;

const FrontCleranceTable = ({ rows, loading = false }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();

  const columns = useMemo(
    () => [
      {
        id: "manufacturerName",
        label: t("FRONT_CLEARANCE.TABLE.MANUFACTURER_NAME"),
        align: "right",
        width: "12.5%",
        format: (row: FrontClearanceRow) =>
          renderValue(row.manufacturerName, styles),
      },
      {
        id: "superModelName",
        label: t("FRONT_CLEARANCE.TABLE.MASTER_MODEL"),
        align: "right",
        width: "12.5%",
        format: (row: FrontClearanceRow) =>
          renderValue(row.superModelName, styles),
      },
      {
        id: "year",
        label: t("FRONT_CLEARANCE.TABLE.YEAR"),
        align: "right",
        width: "12.5%",
        format: (row: FrontClearanceRow) => renderValue(row.year, styles),
      },
      {
        id: "cabinType",
        label: t("FRONT_CLEARANCE.TABLE.DRIVER_CABIN"),
        align: "right",
        width: "12.5%",
        format: (row: FrontClearanceRow) =>
          renderValue(row.cabinType, styles),
      },
      {
        id: "structureTypeName",
        label: t("FRONT_CLEARANCE.TABLE.BODY_TYPE"),
        align: "right",
        width: "12.5%",
        format: (row: FrontClearanceRow) =>
          renderValue(row.structureTypeName, styles),
      },
      {
        id: "normalFrontSpace",
        label: t("FRONT_CLEARANCE.TABLE.OPTIMAL_DISTANCE"),
        align: "right",
        width: "12.5%",
        format: (row: FrontClearanceRow) =>
          renderValue(row.normalFrontSpace, styles),
      },
      {
        id: "minFrontSpace",
        label: t("FRONT_CLEARANCE.TABLE.MINIMAL_DISTANCE"),
        align: "right",
        width: "12.5%",
        format: (row: FrontClearanceRow) =>
          renderValue(row.minFrontSpace, styles),
      },
      {
        id: "remarks",
        label: t("FRONT_CLEARANCE.TABLE.NOTE"),
        align: "right",
        width: "12.5%",
        format: (row: FrontClearanceRow) => renderValue(row.remarks, styles),
      },
    ],
    [styles, t]
  );

  return (
    <div className={styles.root} dir="rtl">
      <DataTable
        rows={rows}
        columns={columns}
        loading={loading && rows.length === 0}
        serialEnabled={false}
        noDataLabel={t("FRONT_CLEARANCE.EMPTY")}
      />
    </div>
  );
};

export default FrontCleranceTable;
